import { Type } from "@angular/core";
import { MapOptionComponent } from "./map-option.component";

export class MapOption<T> {
    constructor(
        public component: Type<MapOptionComponent<T>>,
        public id: string,
        public title: string,
        public data: T,
        public icon: string) { }
}